import React from 'react'
import { useQuery } from 'react-query'

import UICheckbox from './UI/UICheckBox'
import { getWhistleBlowingRouting } from '../api/lead/whistleblowing'
import { whistleBlowingRoutingResponse } from '../utils/types'

interface WhistleBlowingAboutOfficerProps {
  checked: boolean
  onChange: (checked: boolean) => void
}

// Only shown when reports are routed to a named Whistleblowing Officer instead of by role
const WhistleBlowingAboutOfficer = ({
  checked,
  onChange,
}: WhistleBlowingAboutOfficerProps) => {
  const { data } = useQuery('whistleBlowingRouting', async () => {
    const response =
      (await getWhistleBlowingRouting()) as whistleBlowingRoutingResponse
    return response?.data
  })

  if (!data?.enabled) return null

  const officer = data.officerName || 'the Whistleblowing Officer'
  const alternate = data.alternateName || 'an alternate contact'

  return (
    <div className="rounded-xl p-3 bg-gray1 flex flex-col gap-1">
      <UICheckbox
        label={`My report is about ${officer}`}
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <p className="text-sm font-normal leading-6 text-text1">
        {`${officer} is the Whistleblowing Officer and receives every report. Tick this if your concern is about them: your report will go only to ${alternate}, and ${officer} will not see it.`}
      </p>
    </div>
  )
}

export default WhistleBlowingAboutOfficer
